export default {
	权限管理员: {
		菜单: ['主页',
			'业务管理.委外管理', '业务管理.委托申请', '业务管理.委托评审', '业务管理.报价编制', '业务管理.费用申请', '业务管理.委托报价', '业务管理.排工审核', '业务管理.数据引用审批', '业务管理.委托总评审', '业务管理.委托变更修改',
			'样品管理.样品库存管理', '样品管理.样品信息管理.接头角度', '样品管理.样品信息管理.接头锁扣颜色', '样品管理.样品信息管理.接头规格型号', '样品管理.样品信息管理.结构材料', '样品管理.样品信息管理.总成管段规格型号', '样品管理.样品信息管理.样品分类',
			'日常管理.日常任务',
			'检测管理.任务分工', '检测管理.更换主检人', '检测管理.出入厂测试', '检测管理.任务待排工', '检测管理.任务已排工', '检测管理.检测计划', '检测管理.人员计划', '检测管理.设备运行图', '检测管理.数据审核', '检测管理.数据撤回', '检测管理.原始记录导出',
			'报告管理.报告编制', '报告管理.报告审核', '报告管理.报告批准', '报告管理.报告撤回', '报告管理.报告制作', '报告管理.报告领取', '报告管理.合并报告', '报告管理.报告邮件发送',
			'委外管理.委外登记', '委外管理.委外评审', '委外管理.委外费用申请', '委外管理.委外分工', '委外管理.委外报告上传',
			'数据查询.合同查询', '数据查询.样品查询', '数据查询.报告查询', '数据查询.合同进度查询', '数据查询.项目查询', '数据查询.计划查询',
			'标准管理.标准制定', '标准管理.标准审核', '标准管理.标准批准', '标准管理.标准管理', '标准管理.标准/单位管理',
			'实验室管理.人员管理', '实验室管理.消耗品管理', '实验室管理.显示屏分类管理',

			'设备管理.设备信息', '设备管理.设备计量', '设备管理.设备期间核查', '设备管理.设备维护保养',
			'设备管理.设备维修.维修申请', '设备管理.设备维修.故障确认', '设备管理.设备维修.设备维修', '设备管理.设备维修.结果确认', '设备管理.设备维修.记录上传', '设备管理.设备维修.维修查询',
			'设备管理.安全操作规程.操作规程编写', '设备管理.安全操作规程.操作规程审批', '设备管理.安全操作规程.操作规程查询',
			'体系管理.体系文件管理', '体系管理.体系文件起草.文件编制', '体系管理.体系文件起草.文件审核', '体系管理.体系文件起草.文件批准', '体系管理.体系文件起草.起草查询',
			'体系管理.体系文件修订.修订申请', '体系管理.体系文件修订.修订审核', '体系管理.体系文件修订.修订批准', '体系管理.体系文件修订.修订查询', '体系管理.体系文件销毁.销毁申请',
			'体系管理.体系文件销毁.销毁审核', '体系管理.体系文件销毁.销毁批准', '体系管理.体系文件销毁.文件销毁', '体系管理.体系文件销毁.销毁查询',
			'项目费用管理.项目费用管理', '项目费用管理.项目费用审批', '项目费用管理.项目费用使用审批', '项目费用管理.项目续费审批',

			'报表管理.数据统计',
			'系统管理.系统参数',
		]
	},

	设备管理员: {
		菜单: ['主页',
			'检测管理.设备运行图', '检测管理.人员计划图',
			'设备管理.设备信息', '设备管理.设备计量', '设备管理.设备期间核查', '设备管理.设备维护保养',
			'设备管理.设备维修.故障确认', '设备管理.设备维修.设备维修', '设备管理.设备维修.记录上传', '设备管理.设备维修.维修查询',
			'设备管理.安全操作规程.操作规程编写', '设备管理.安全操作规程.操作规程审批', '设备管理.安全操作规程.操作规程查询',
		]
	},

	总设备管理员: {
		菜单: ['主页',
			'设备管理.设备信息', '设备管理.设备计量', '设备管理.设备期间核查', '设备管理.设备维护保养',
			'设备管理.设备维修.故障确认', '设备管理.设备维修.设备维修', '设备管理.设备维修.记录上传', '设备管理.设备维修.维修查询',
			'设备管理.安全操作规程.操作规程编写', '设备管理.安全操作规程.操作规程审批', '设备管理.安全操作规程.操作规程查询',
		]
	},

	设备查看: {
		菜单: ['主页',
			'设备管理.设备信息', '设备管理.设备维修.故障确认', '设备管理.设备维修.设备维修', '设备管理.设备维修.记录上传', '设备管理.设备维修.维修查询',
			'设备管理.安全操作规程.操作规程编写', '设备管理.安全操作规程.操作规程审批', '设备管理.安全操作规程.操作规程查询',
		]
	},

	设备计划执行人: {
		菜单: ['主页',
			'设备管理.设备计量', '设备管理.设备期间核查', '设备管理.设备维护保养',
		]
	},

	实验员: {
		菜单: ['主页',
			'业务管理.委外管理', '检测管理.出入厂测试', '检测管理.任务待排工', '检测管理.任务已排工', '检测管理.检测计划', '检测管理.人员计划', '检测管理.设备运行图', '委外管理.委外报告上传',
			'数据查询.合同查询',

			'设备管理.设备维修.维修申请', '设备管理.设备维修.结果确认', '设备管理.设备维修.维修查询',
			'设备管理.安全操作规程.操作规程编写', '设备管理.安全操作规程.操作规程审批', '设备管理.安全操作规程.操作规程查询',
		]
	},

	技术负责人: {
		菜单: ['主页',
			'设备管理.安全操作规程.操作规程审批', '设备管理.安全操作规程.操作规程查询',
			'项目费用管理.项目费用审批',
		]
	},

	委托人: {
		菜单: ['主页',
			'业务管理.委外管理', '业务管理.委托申请', '业务管理.费用申请', '报告管理.报告制作', '委外管理.委外登记', '委外管理.委外费用申请',
			'数据查询.合同查询', '数据查询.报告查询',
			'项目费用管理.项目费用管理', '项目费用管理.项目费用使用审批',
		]
	},

	'委托人(仅自己)': {
		菜单: ['主页',
			'业务管理.委外管理', '业务管理.委托申请', '报告管理.报告制作',
			'委外管理.委外登记', '委外管理.委外费用申请',
			'数据查询.合同查询', '数据查询.报告查询',
			'项目费用管理.项目费用管理', '项目费用管理.项目费用使用审批',
		]
	},

	'委托人（廊坊）': {
		菜单: ['主页',
			'业务管理.委托申请', '数据查询.合同查询', '数据查询.报告查询',
			'项目费用管理.项目费用管理', '项目费用管理.项目费用使用审批',
		]
	},

	业务受理员: {
		菜单: ['主页',
			'业务管理.报告制作', '业务管理.报告领取', '业务管理.报告邮件发送',
			'数据查询.合同查询', '数据查询.报告查询', '报表管理.数据统计',
		],
	},

	委托人部门领导: {
		菜单: ['主页',
			'业务管理.数据引用审批',
			'数据查询.合同查询',
			'项目费用管理.项目续费审批',
		],
	},

	管理员: {
		菜单: ['主页',
			'业务管理.委外管理', '业务管理.委托申请', '业务管理.委托评审', '业务管理.委托变更修改', '业务管理.委托报价',
			'样品管理.样品库存管理', '样品管理.样品信息管理.接头角度', '样品管理.样品信息管理.接头锁扣颜色', '样品管理.样品信息管理.接头规格型号', '样品管理.样品信息管理.结构材料', '样品管理.样品信息管理.总成管段规格型号', '样品管理.样品信息管理.样品分类',
			'检测管理.任务分工', '检测管理.出入厂测试', '检测管理.任务待排工', '检测管理.任务已排工', '检测管理.检测计划', '检测管理.人员计划', '检测管理.设备运行图', '检测管理.数据审核', '检测管理.数据撤回',
			'报告管理.报告编制', '报告管理.报告审核', '报告管理.报告批准', '报告管理.报告撤回', '报告管理.报告制作', '报告管理.报告领取', '报告管理.合并报告',
			'数据查询.合同查询', '数据查询.样品查询', '数据查询.报告查询', '数据查询.合同进度查询', '数据查询.项目查询', '数据查询.计划查询',
			'标准管理.标准管理', '实验室管理.人员管理', '实验室管理.消耗品管理', '实验室管理.显示屏分类管理', '报表管理.数据统计',

			'设备管理.设备维修.维修申请', '设备管理.设备维修.结果确认', '设备管理.设备维修.维修查询',
			'设备管理.安全操作规程.操作规程编写', '设备管理.安全操作规程.操作规程审批', '设备管理.安全操作规程.操作规程查询',
		]
	},

	委外合同评审员: {
		菜单: ['主页',
			'业务管理.委外管理', '委外管理.委外登记', '委外管理.委外评审', '委外管理.委外费用申请', '委外管理.委外分工',
		]
	},

	'合同评审员（上海）': {
		菜单: ['主页',
			'业务管理.委托评审', '业务管理.委托变更修改', '业务管理.委托报价', '检测管理.任务分工', '检测管理.任务待排工', '检测管理.任务已排工', '检测管理.数据审核', '检测管理.数据撤回',
			'数据查询.合同查询', '数据查询.样品查询', '数据查询.项目查询', '数据查询.计划查询', '标准管理.标准/单位管理',
		]
	},

	'合同评审员（河北、长春）': {
		菜单: ['主页',
			'业务管理.委托评审', '业务管理.委托变更修改', '业务管理.委托报价', '数据查询.合同查询', '数据查询.样品查询', '数据查询.项目查询', '数据查询.计划查询', '标准管理.标准/单位管理',
		]
	},

	'合同评审员（出入厂）': {
		菜单: ['主页',
			'业务管理.委托评审', '业务管理.委托变更修改', '业务管理.委托报价', '检测管理.任务分工', '检测管理.数据审核', '检测管理.数据撤回',
			'数据查询.合同查询', '数据查询.样品查询', '数据查询.项目查询', '数据查询.计划查询', '标准管理.标准/单位管理',
		]
	},

	'合同评审员（廊坊）': {
		菜单: ['主页',
			'业务管理.委托评审', '业务管理.委托变更修改', '数据查询.合同查询', '数据查询.报告查询', '标准管理.标准/单位管理',
		],
	},

	实验室主任: {
		菜单: ['主页',
			'业务管理.排工审核', '业务管理.数据引用审批', '业务管理.委托评审', '业务管理.委托变更修改', '业务管理.委托报价', '检测管理.更换主检人',
			'数据查询.合同查询', '数据查询.样品查询', '数据查询.报告查询', '数据查询.项目查询',
			'标准管理.标准管理',
		]
	},

	'实验室主任（廊坊）': {
		菜单: ['主页',
			'业务管理.数据引用审批',
			'数据查询.合同查询', '数据查询.报告查询', '数据查询.项目查询',
		]
	},

	总合同评审员: {
		菜单: ['主页',
			'业务管理.委托总评审', '检测管理.任务分工', '数据查询.合同查询', '标准管理.标准/单位管理',
		],
	},

	样品管理员: {
		菜单: ['主页',
			'样品管理.样品库存管理',
		],
	},

	样品信息管理员: {
		菜单: ['主页',
			'样品管理.样品信息管理.接头角度', '样品管理.样品信息管理.接头锁扣颜色', '样品管理.样品信息管理.接头规格型号', '样品管理.样品信息管理.结构材料', '样品管理.样品信息管理.总成管段规格型号', '样品管理.样品信息管理.样品分类',
		],
	},

	任务执行人: {
		菜单: ['主页',
			'日常管理.日常任务',
		]
	},

	主检小组分工: {
		菜单: ['主页',
			'检测管理.任务分工',
		]
	},

	任务分工: {
		菜单: ['主页',
			'检测管理.任务分工', '检测管理.检测计划',
		]
	},

	'计划管理（上海）': {
		菜单: ['主页',
			'检测管理.任务待排工', '检测管理.任务已排工',
		]
	},

	'检测计划查询(上海)': {
		菜单: ['主页',
			'检测管理.检测计划',
		]
	},

	小组负责人: {
		菜单: ['主页',
			'检测管理.数据审核', '检测管理.数据撤回', '报表管理.数据统计',
			'设备管理.设备信息', '设备管理.设备维修.故障确认', '设备管理.设备维修.设备维修', '设备管理.设备维修.记录上传', '设备管理.设备维修.维修查询',
			'设备管理.安全操作规程.操作规程编写', '设备管理.安全操作规程.操作规程审批', '设备管理.安全操作规程.操作规程查询',
		]
	},

	数据校核: {
		菜单: ['主页',
			'检测管理.数据审核', '检测管理.数据撤回',
		]
	},

	组长数据审核: {
		菜单: ['主页',
			'检测管理.数据审核', '检测管理.数据撤回',
		]
	},

	数据撤回: {
		菜单: ['主页',
			'检测管理.数据撤回',
		],
	},

	'数据撤回（上海）': {
		菜单: ['主页',
			'检测管理.数据撤回',
		],
	},

	报告编制员: {
		菜单: ['主页',
			'报告管理.报告编制', '报告管理.报告制作', '报告管理.报告领取', '报告管理.合并报告',
			'数据查询.合同查询', '数据查询.报告查询',
		]
	},

	报告审核员: {
		菜单: ['主页',
			'报告管理.报告审核', '数据查询.报告查询',
		]
	},

	授权签字人: {
		菜单: ['主页',
			'报告管理.报告批准', '报告管理.报告撤回', '数据查询.合同查询', '数据查询.报告查询',
		]
	},

	合同查询: {
		菜单: ['主页',
			'数据查询.合同查询', '数据查询.报告查询',
		]
	},

	'合同查询（上海）': {
		菜单: ['主页',
			'数据查询.合同查询',
		]
	},

	'合同查询（河北）': {
		菜单: ['主页',
			'数据查询.合同查询', '数据查询.报告查询',
		]
	},

	合同进度查询: {
		菜单: ['主页',
			'数据查询.合同进度查询',
		]
	},

	标准管理: {
		菜单: ['主页',
			'标准管理.标准制定', '标准管理.标准审核', '标准管理.标准批准', '标准管理.标准管理',
		]
	},

	人员管理: {
		菜单: ['主页',
			'实验室管理.人员管理',
		]
	},

	消耗品管理员: {
		菜单: ['主页',
			'实验室管理.消耗品管理员',
		]
	},
	公有权限: {
		菜单: ['主页',
			'体系管理.体系文件管理', '体系管理.体系文件修订.修订申请', '体系管理.体系文件修订.修订查询',
		]
	},
	文件管理员: {
		菜单: ['主页',
			'体系管理.体系文件管理', '体系管理.体系文件销毁.文件销毁', '体系管理.体系文件销毁.销毁查询',
		]
	},
	文件起草人: {
		菜单: ['主页',
			'体系管理.体系文件起草.文件编制', '体系管理.体系文件起草.起草查询', '体系管理.体系文件销毁.销毁审核', '体系管理.体系文件销毁.销毁查询',
		]
	},
	文件审核人: {
		菜单: ['主页',
			'体系管理.体系文件起草.文件审核', '体系管理.体系文件起草.起草查询', '体系管理.体系文件修订.修订审核', '体系管理.体系文件修订.修订查询',
		]
	},
	文件批准人: {
		菜单: ['主页',
			'体系管理.体系文件起草.文件批准', '体系管理.体系文件起草.起草查询', '体系管理.体系文件修订.修订批准', '体系管理.体系文件修订.修订查询',
		]
	},
	文件批准人: {
		菜单: ['主页',
			'体系管理.体系文件起草.文件批准', '体系管理.体系文件起草.起草查询', '体系管理.体系文件修订.修订批准', '体系管理.体系文件修订.修订查询',
		]
	},
	质量负责人: {
		菜单: ['主页',
			'体系管理.体系文件销毁.销毁申请', '体系管理.体系文件销毁.销毁查询', '体系管理.体系文件管理',
		]
	},
	实验室主管: {
		菜单: ['主页',
			'体系管理.体系文件销毁.销毁批准', '体系管理.体系文件销毁.销毁查询',
		]
	},
	原始记录导出: {
		菜单: [
			'主页', '检测管理.原始记录导出'
		]
	},
	'人员计划图(河北)': {
		菜单: ['主页',
			'检测管理.人员计划图',
		]
	},
	委托变更: {
		菜单: [
			'主页', '业务管理.委托申请', '数据查询.合同查询'
		]
	},
	报价人员: {
		菜单: [
			'业务管理.报价编制'
		]
	},
}